import { BasketItem } from "./types";
import moment from "moment";

function basketItemsToOrderRequest(basketItems: BasketItem[]) {
  return basketItems.map(basketItem => ({
    requiredAt: moment(basketItem.required, "DD/MM/YYYY")
      .utc()
      .format("YYYY-MM-DDTHH:mm:SSZ"),
    currencyAmount: basketItem.currencyAmount,
    currencyId: basketItem.currencyId,
    travellerBeneficiary: basketItem.travellerBeneficiary,
    comments: basketItem.comments,
    referenceForInvoice: basketItem.referenceForInvoice,
    denominations: basketItem.denominations,
    branchId: basketItem.branchId,
    settlementSource:
      basketItem.settlementSource && parseInt(basketItem.settlementSource)
  }));
}

export default basketItemsToOrderRequest;
